import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Paper,
} from "@mui/material";
import { Link } from "react-router-dom";
import apiClient from "../../services/apiClient";
import SEO from "../../components/SEO";

export default function AdminLeadsPage() {
  const [q, setQ] = useState("");
  const [data, setData] = useState({ rows: [], total: 0 });

  const load = useCallback(() => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    apiClient.request(`/api/admin/leads?${params.toString()}`).then(setData);
  }, [q]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <SEO title="Admin Leads | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 1 }}>4. Leads entrants</Typography>
      <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
        Ici tu suis les leads du site (formulaires, guide, Calendly). Les prospects outbound sont dans Pipeline/Shortlist.
      </Typography>
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <TextField
          label="Recherche nom/email"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          size="small"
        />
        <Button variant="contained" onClick={load}>Filtrer</Button>
      </Box>
      <Paper sx={{ overflow: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Nom</TableCell>
              <TableCell>Source</TableCell>
              <TableCell>Statut</TableCell>
              <TableCell>Sequence</TableCell>
              <TableCell>RDV</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.rows?.map((lead) => (
              <TableRow key={lead.id}>
                <TableCell>{lead.email}</TableCell>
                <TableCell>{`${lead.first_name || ""} ${lead.last_name || ""}`.trim()}</TableCell>
                <TableCell>{lead.source}</TableCell>
                <TableCell>{lead.status}</TableCell>
                <TableCell>{lead.sequence_status}</TableCell>
                <TableCell>{lead.rdv_booked ? "Oui" : "Non"}</TableCell>
                <TableCell>
                  <Button component={Link} to={`/admin/leads/${lead.id}`} size="small">Voir</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
}
